// imports
import { gsap, ScrollToPlugin } from 'gsap/all';
import Highway from '@dogstudio/highway/src/highway';
import EventDispatcher from 'minsky-kit/js/managers/EventDispatcher';
import { listen } from 'quicklink/dist/quicklink.mjs';
import HighwayRenderer from './HighwayRenderer';
import HighwayTransitions from './HighwayTransitions';
import 'intersection-observer';

// private statics

// class definition
export default class MinskyHighway extends EventDispatcher {
    // constructor
    constructor(args = {}, objectName = 'MinskyHighway') {
        args.debug = args.debug || true;

        gsap.registerPlugin(ScrollToPlugin);

        // super
        super(args, objectName);

        // set properties
        this._navigationLinks = args.navigationLinks || [];

        // init highway
        this._highway = new Highway.Core({
            renderers: {
                general: HighwayRenderer,
            },
            transitions: {
                general: HighwayTransitions,
            },
        });

        // add listeners
        this._highway.on('NAVIGATE_IN', this.blm.add('onNavIn', onNavIn));
        this._highway.on('NAVIGATE_OUT', this.blm.add('onNavOut', onNavOut));
        this._highway.on('NAVIGATE_END', this.blm.add('onNavEnd', onNavEnd));

        // listen quicklinks
        initPrefetch.call(this, document.body.querySelector('.page__inner'));
        detachLinks.call(this);
    }

    // methods
    refresh() {

    }

    attach(links) {
        this._highway.attach(links);
    }

    detach(links) {
        this._highway.detach(links);
    }

    destroy() {
        super.destroy();
    }

    // getters & setters
}

// Utils
function initPrefetch(view) {
    listen({
        el: view,
        delay: 10,
        throttle: 5,
    });
}

function wakeDrupal() {
    this.log('waky waky');
    this.dispatch('beforeDrupalRefresh');
    Drupal.attachBehaviors();
}

function cleanUrl(url) {
    return url.replace(/#.*$/, '').replace(/\?.*$/, '');
}

function updateNavigationLinkStates(url) {
    const curLink = cleanUrl(url);
    this._navigationLinks.forEach(($link) => {
        // remove active state if necessary
        $link.classList.remove('is-active');
        $link.parentNode.classList.remove('menu__item--active-trail');

        // apply active state if clean urls match
        const linkUrl = cleanUrl($link.getAttribute('href'));
        if (curLink === linkUrl) {
            $link.classList.add('is-active');

            if ($link.classList.contains('menu__link')) {
                $link.parentNode.classList.add('menu__item--active-trail');
            }
        }
    });
}

function detachLinks() {
    this._highway.detach(document.querySelectorAll([
        'form',
        '.pager__link',
        '.views-exposed-form, .views-exposed-form input, .views-exposed-form button',
        '.editor-actions a',
        '.toolbar-bar a',
        '.accordion__title-wrapper',
    ].join(',')));
}

function updateGTag() {
    if (typeof gtag !== 'undefined') {
        // gtag('config', 'GTM-NSQ9C4Q', {
        //     page_path:     location.pathname,
        //     page_title:    to.page.title,
        //     page_location: location.href,
        // });
    }
}

// Event handlers
function onNavIn({ location }) {
    this.log('nav in');
    wakeDrupal.call(this);
    updateNavigationLinkStates.call(this, location.pathname);

    // clear cache if logged in
    if (document.body.classList.contains('page--loggedIn')) {
        this._highway.cache.clear();
    }
}

function onNavOut() {
    // gsap.to(window, { duration: 0, scrollTo: 0, ease: 'sine-in-out' });
}

function onNavEnd({ to }) {
    this.log('nav end');
    initPrefetch.call(this, to.view);
    detachLinks.call(this);
    updateGTag.call(this);
    gsap.to(window, { duration: 0, scrollTo: 0 });
}
